module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"add":"Neu","learningDepartments":"Abteilungen"},"en":{"add":"Add","learningDepartments":"LearningDepartments"}}')
  delete Component.options._Ctor
}
